// extracted by mini-css-extract-plugin
export default {"Row":"FieldLabSamplesChart_Row__99b8R","Link":"FieldLabSamplesChart_Link__uGPLQ"};